import axios from 'axios';

const { REACT_APP_STAGE } = process.env;

const v2api = axios.create({
  baseURL: `https://v2.transrec.net/2022-05/back/${REACT_APP_STAGE}/`,
});

const v2apiBlob = axios.create({
  baseURL: `https://v2.transrec.net/2022-05/back/${REACT_APP_STAGE}/`,
  responseType: 'blob',
});

export { v2api, v2apiBlob };
